import { render, staticRenderFns } from "./emptySwitchOrderList.vue?vue&type=template&id=7a1a8921&scoped=true"
import script from "./emptySwitchOrderList.vue?vue&type=script&lang=js"
export * from "./emptySwitchOrderList.vue?vue&type=script&lang=js"
import style0 from "./emptySwitchOrderList.vue?vue&type=style&index=0&id=7a1a8921&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1a8921",
  null
  
)

export default component.exports